export default __webpack_public_path__ + "static/media/r8.1cdb447b.jpg";